<div class="filter-button" (click)="op.toggle($event)" matRipple [matRippleCentered]="true">
	<button mat-button disableRipple="true">
		<mat-icon>filter_list</mat-icon>
	</button>
	<div class="types-info" *ngIf="filterIsOn">{{countRoles}} roles</div>
</div>

<p-overlayPanel #op>
	<div class="users-filter-checkboxes">
		<!-- <p-checkbox *ngFor="let types of selectedTypes" label="{{types}}" name="types" value="{{types}}" [(ngModel)]="selectedTypes" (click)="clickOnFilter()"></p-checkbox> -->
		<p-checkbox class="all-button" label="All" name="types" [binary]="true" [(ngModel)]="showAll"
			(click)="showAllButton()"></p-checkbox>
		<p-checkbox *ngFor="let role of roles" label="{{role.name}}" name="types" value="{{role.name}}"
			[(ngModel)]="selectedRoles" (click)="clickOnFilter()"></p-checkbox>
	</div>

</p-overlayPanel>